<script setup lang="ts">
import { ChatAlt2Icon, ChevronRightIcon } from "@heroicons/vue/outline";

type Props = {
  count?: number | null;
  label?: string;
};

type Emits = {
  (e: "click", event: MouseEvent): void;
};

const { count = null, label = "" } = defineProps<Props>();

defineEmits<Emits>();
</script>

<template>
  <button
    type="button"
    class="flex items-center justify-center gap-1.5 rounded border-2 border-kekkle-dark bg-kekkle-purple-light/30 py-2 text-xs font-bold text-kekkle-dark shadow-purple-hard-sm transition-all hover:bg-kekkle-purple-light/60 active:translate-y-0.5 active:shadow-none dark:border-slate-600 dark:bg-kekkle-dark-light dark:text-purple-300"
    @click="$emit('click', $event)"
  >
    <ChatAlt2Icon class="h-4 w-4" />
    <span>{{ label || $t("components.comment.title", "Comments") }}</span>
    <span
      v-if="count !== undefined && count !== null && count > 0"
      class="ml-0.5 rounded-full bg-kekkle-purple px-2 py-0.5 text-[10px] font-extrabold text-white"
    >
      {{ count }}
    </span>
    <ChevronRightIcon class="h-3.5 w-3.5" />
  </button>
</template>
